import PropTypes from 'prop-types';

const ArrowRightIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.08 41.062c-1.628 1.763-4.233 1.88-5.97.118-1.627-1.762-1.736-4.582-.108-6.462l5.753-6.344H4.233C1.953 28.374 0 26.376 0 23.792c0-2.468 1.845-4.582 4.233-4.582h29.522l-5.753-6.345c-1.628-1.762-1.628-4.7.109-6.462.868-.822 1.845-1.292 2.93-1.292 1.086 0 2.171.47 3.04 1.41L46.778 20.62c1.628 1.762 1.628 4.582 0 6.344L34.08 41.062z"
        fill={fill}
        fillRule="nonzero"
      />
    </svg>
  </div>
);

ArrowRightIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

ArrowRightIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default ArrowRightIcon;
